import { createAsyncThunk } from '@reduxjs/toolkit'
import doAsync from '../../infrastructure/doAsync'
import { REGIONS } from '../../widgets/busyIndicator'

export const fetchAllReleaseNotes = createAsyncThunk(
	'releaseNotes/getAll',
	async ({ noBusySpinner } = {}, thunkArgs) =>
		await doAsync({
			url: 'api/releaseNotes',
			noBusySpinner,
			errorMessage: 'Unable to fetch release notes. Please try again later.',
			busyIndicatorName: REGIONS.FETCH_RELEASE_NOTES,
			...thunkArgs,
		})
)

export const addReleaseNotes = createAsyncThunk(
	'releaseNotes/add',
	async (releaseNote, thunkArgs, { noBusySpinner } = {}) => {
		const id = !!releaseNote && releaseNote.id
		!!releaseNote && delete releaseNote.id
		return await doAsync({
			url: 'api/releaseNotes',
			httpMethod: 'post',
			httpConfig: {
				body: JSON.stringify({ releaseNote }),
			},
			noBusySpinner,
			errorMessage: 'Unable to add release notes. Please try again later.',
			busyIndicatorName: `${id}`,
			...thunkArgs,
		})
	}
)

export const deleteReleaseNote = createAsyncThunk(
	'releaseNote/delete',
	async (id, thunkArgs, { noBusySpinner } = {}) =>
		await doAsync({
			url: `api/releaseNotes/${id}`,
			httpMethod: 'delete',
			noBusySpinner,
			errorMessage: 'Unable to delete release note. Please try again later.',
			busyIndicatorName: REGIONS.DELETE_RELEASE_NOTE,
			...thunkArgs,
		})
)

export const editReleaseNote = createAsyncThunk(
	'releaseNote/edit',
	async (data, thunkArgs, { noBusySpinner } = {}) =>
		await doAsync({
			url: `api/releaseNotes/${data.id}`,
			httpMethod: 'put',
			httpConfig: {
				body: JSON.stringify(data),
			},
			noBusySpinner,
			errorMessage: 'Unable to update release note. Please try again later.',
			busyIndicatorName: data.id,
			...thunkArgs,
		})
)
